sliders = {
	//Инициализировать все слайдеры на странице
	init: function() {
		var
			$sliders = $('.js-slider');

		$sliders.each(function() {
			var
				$container = $(this),
				$slider = $container.find('.swiper'),
				$pagination = $container.find('.js-slider-pagination'),
				$navigation = $container.find('.js-slider-prev, .js-slider-next'),
				buf = {},
				params = {
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
				};

			if ($pagination.length && typeof $pagination.attr('id') !== 'undefined') {
				params.pagination = {};
				params.pagination.el = '#' + $pagination.attr('id');
				params.pagination.clickable = true;
			}

			if ($navigation.length) {
				params.navigation = {};
				params.navigation.prevEl = '#' + $navigation.filter('.js-slider-prev').attr('id');
				params.navigation.nextEl = '#' + $navigation.filter('.js-slider-next').attr('id');
			}

			if (isset($slider.attr('data-slider-params'))) {
				buf = JSON.parse($slider.attr('data-slider-params'));

				for (var key in buf)
					params[key] = buf[key];
			}

			new Swiper($slider.get(0), params);
		});


	}
}

jQuery(document).ready(function() {
	sliders.init();
});